/* Livelor · comportements des sections lv-* */
(function(){
  // Apparition douce des sections
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('lv-vu'); io.unobserve(e.target); } });
  },{rootMargin:'0px 0px -8% 0px'}) : null;
  function initApparition(root){
    (root||document).querySelectorAll('.lv-cascade').forEach(function(liste){
      Array.prototype.forEach.call(liste.children, function(enfant, i){ enfant.style.setProperty('--i', i); });
    });
    (root||document).querySelectorAll('.lv-apparait:not(.lv-vu)').forEach(function(el){ io ? io.observe(el) : el.classList.add('lv-vu'); });
  }

  // Page produit : galerie, coloris, offres, barre collée
  function initProduit(root){
    (root||document).querySelectorAll('[data-lv-produit]').forEach(function(p){
      if(p.dataset.lvInit) return; p.dataset.lvInit='1';
      var rail = p.querySelector('[data-lv-rail]');
      var vignettes = p.querySelectorAll('[data-lv-vignette]');
      var points = p.querySelectorAll('[data-lv-point]');
      var bande = p.querySelector('.lvp-vignettes');
      var prec = p.querySelector('[data-lv-prec]'), suiv = p.querySelector('[data-lv-suiv]');
      var courant = 0, total = rail ? rail.children.length : 0;
      function marquer(i){
        courant = i;
        vignettes.forEach(function(v,j){ v.classList.toggle('actif', j===i); });
        points.forEach(function(v,j){ v.classList.toggle('actif', j===i); });
        if(prec) prec.disabled = i <= 0;
        if(suiv) suiv.disabled = i >= total - 1;
        var v = vignettes[i];
        if(bande && v && bande.scrollWidth > bande.clientWidth){
          bande.scrollTo({left: v.offsetLeft - (bande.clientWidth - v.offsetWidth) / 2, behavior:'smooth'});
        }
      }
      function aller(i){
        var s = rail && rail.children[i]; if(!s) return;
        rail.scrollTo({left: s.offsetLeft - rail.offsetLeft, behavior:'smooth'}); marquer(i);
      }
      vignettes.forEach(function(v,i){ v.addEventListener('click', function(){ aller(i); }); });
      if(prec) prec.addEventListener('click', function(){ aller(courant - 1); });
      if(suiv) suiv.addEventListener('click', function(){ aller(courant + 1); });
      if(rail){
        var t; rail.addEventListener('scroll', function(){ clearTimeout(t); t=setTimeout(function(){
          var i = Math.round(rail.scrollLeft / rail.clientWidth); if(i !== courant) marquer(i);
        },80); }, {passive:true});
      }
      // Coloris
      var champId = p.querySelector('[data-lv-variante]');
      var libColoris = p.querySelector('[data-lv-coloris-nom]');
      p.querySelectorAll('[data-lv-coloris]').forEach(function(b){
        b.addEventListener('click', function(){
          p.querySelectorAll('[data-lv-coloris]').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
          b.setAttribute('aria-pressed','true');
          if(champId) champId.value = b.dataset.lvColoris;
          if(libColoris) libColoris.textContent = b.dataset.lvNom;
          var idx = parseInt(b.dataset.lvMedia,10); if(!isNaN(idx)) aller(idx);
          document.querySelectorAll('[data-lv-coloris-copie]').forEach(function(i){ i.value = b.dataset.lvColoris; });
          majRangeeTailles();
        });
      });
      // Couleur et taille de chaque pièce dans l'offre choisie.
      // Tailles (2e option du produit, ex. M, L, XL) : la section pose une carte couleur → taille → identifiant de variante
      // et la liste des variantes épuisées. Sans carte (produit à une seule option), seule la couleur compte.
      var choix = [], defaut = champId ? champId.value : '';
      var carteTailles = null, inverseTailles = {}, epuisees = {};
      var carteEl = p.querySelector('[data-lv-carte-variantes]');
      if(carteEl){ try { carteTailles = JSON.parse(carteEl.textContent); } catch(err){ carteTailles = null; } }
      var epuiseesEl = p.querySelector('[data-lv-variantes-epuisees]');
      if(epuiseesEl){ try { JSON.parse(epuiseesEl.textContent).forEach(function(id){ epuisees[String(id)] = true; }); } catch(err){} }
      if(carteTailles){
        Object.keys(carteTailles).forEach(function(c){
          Object.keys(carteTailles[c]).forEach(function(t){ inverseTailles[String(carteTailles[c][t])] = { couleur: c, taille: t }; });
        });
      }
      var aPieces = !!p.querySelector('[data-lv-piece]');
      // tailleG : taille de la rangée « Tailles », pour toutes les pièces ; taillesP[i] : taille choisie dans la ligne de la pièce i
      var tailleG = inverseTailles[String(defaut)] ? inverseTailles[String(defaut)].taille : '', taillesP = [];
      function idTaille(id, t){
        var x = inverseTailles[String(id)];
        var n = x && carteTailles[x.couleur] && carteTailles[x.couleur][t];
        return n ? String(n) : String(id);
      }
      function dispo(c, t){ var n = carteTailles && carteTailles[c] && carteTailles[c][t]; return !!n && !epuisees[String(n)]; }
      function basePiece(i){ return String(choix[i] || choix[0] || defaut); }
      // Taille d'une pièce : celle de sa ligne, sinon celle de la rangée ; absente pour cette couleur : la 1re disponible
      function taillePiece(i){
        var x = inverseTailles[basePiece(i)]; if(!x) return '';
        var t = taillesP[i] || tailleG || x.taille;
        if(dispo(x.couleur, t)) return t;
        var ts = Object.keys(carteTailles[x.couleur] || {});
        for(var k = 0; k < ts.length; k++){ if(dispo(x.couleur, ts[k])) return ts[k]; }
        return t;
      }
      // Variante d'une pièce : sa couleur (sinon celle de la 1re pièce) dans sa taille
      function couleurPiece(i){
        var id = basePiece(i), x = inverseTailles[id];
        var n = x && carteTailles[x.couleur][taillePiece(i)];
        return n ? String(n) : id;
      }
      function peindre(carte){
        if(!carte) return;
        carte.querySelectorAll('[data-lv-piece]').forEach(function(rang){
          var id = couleurPiece(+rang.dataset.lvPiece), x = inverseTailles[id], nom = '';
          rang.querySelectorAll('[data-lv-couleur]').forEach(function(b){
            var actif = x ? b.dataset.lvNom === x.couleur : b.dataset.lvCouleur === id;
            b.setAttribute('aria-pressed', actif ? 'true' : 'false');
            if(actif) nom = b.dataset.lvNom;
          });
          var bt = rang.querySelectorAll('[data-lv-taille-piece]');
          bt.forEach(function(b){
            var t = b.dataset.lvTaillePiece;
            b.setAttribute('aria-pressed', x && t === x.taille ? 'true' : 'false');
            b.disabled = !!x && !dispo(x.couleur, t);
          });
          var n = rang.querySelector('[data-lv-piece-nom]');
          if(n && nom) n.textContent = bt.length && x ? nom + ' · ' + x.taille : nom;
        });
      }
      // Rangée « Tailles » : la taille commune est cochée ; pièces de tailles différentes : aucune cochée,
      // le libellé cite les tailles (ex. « Taille : L · M »)
      function majRangeeTailles(){
        if(!carteTailles) return;
        var carte = p.querySelector('[data-lv-offre].choisie'), ts = [];
        var rangs = carte && aPieces ? carte.querySelectorAll('[data-lv-piece]') : [];
        if(rangs.length){
          Array.prototype.forEach.call(rangs, function(rang){ var t = taillePiece(+rang.dataset.lvPiece); if(t && ts.indexOf(t) < 0) ts.push(t); });
        } else {
          var x = inverseTailles[String(champId ? champId.value : defaut)]; if(x) ts.push(x.taille);
        }
        var seule = ts.length === 1 ? ts[0] : '';
        p.querySelectorAll('[data-lv-taille]').forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.lvTaille === seule ? 'true' : 'false'); });
        if(ts.length) p.querySelectorAll('[data-lv-taille-nom]').forEach(function(n){ n.textContent = ts.join(' · '); });
      }
      function majPieces(){
        peindre(p.querySelector('[data-lv-offre].choisie'));
        if(aPieces){
          if(champId) champId.value = couleurPiece(0);
          document.querySelectorAll('[data-lv-coloris-copie]').forEach(function(x){ x.value = couleurPiece(0); });
        }
        majRangeeTailles();
      }
      p.querySelectorAll('[data-lv-piece]').forEach(function(rang){
        var i = +rang.dataset.lvPiece;
        rang.querySelectorAll('[data-lv-couleur]').forEach(function(b){
          b.addEventListener('click', function(){
            choix[i] = b.dataset.lvCouleur;
            majPieces();
            var idx = parseInt(b.dataset.lvMedia,10); if(!isNaN(idx)) aller(idx);
          });
        });
        rang.querySelectorAll('[data-lv-taille-piece]').forEach(function(b){
          b.addEventListener('click', function(){
            if(b.disabled) return;
            taillesP[i] = b.dataset.lvTaillePiece;
            majPieces();
          });
        });
      });
      // Rangée « Tailles » : la taille choisie vaut pour toutes les pièces (elle remplace les tailles choisies ligne par ligne)
      function choisirTaille(t){
        if(!carteTailles) return;
        tailleG = t; taillesP = [];
        p.querySelectorAll('[data-lv-couleur]').forEach(function(b){
          var n = carteTailles[b.dataset.lvNom] && carteTailles[b.dataset.lvNom][t]; if(n) b.dataset.lvCouleur = String(n);
        });
        p.querySelectorAll('[data-lv-coloris]').forEach(function(b){
          var n = carteTailles[b.dataset.lvNom] && carteTailles[b.dataset.lvNom][t]; if(n) b.dataset.lvColoris = String(n);
        });
        defaut = idTaille(defaut, t);
        if(!aPieces){
          if(champId) champId.value = idTaille(champId.value, t);
          document.querySelectorAll('[data-lv-coloris-copie]').forEach(function(x){ x.value = idTaille(x.value, t); });
        }
        majPieces();
      }
      p.querySelectorAll('[data-lv-taille]').forEach(function(b){
        b.addEventListener('click', function(){ choisirTaille(b.dataset.lvTaille); });
      });
      // Guide des tailles : la fenêtre (dialog) est placée dans body, hors des sections animées
      p.querySelectorAll('[data-lv-guide-ouvrir]').forEach(function(o){
        var d = document.getElementById(o.dataset.lvGuideOuvrir);
        if(!d) return;
        if(d.parentNode !== document.body){
          Array.prototype.forEach.call(document.body.children, function(x){ if(x !== d && x.id === d.id) x.remove(); });
          document.body.appendChild(d);
        }
        function fermer(){ if(typeof d.close === 'function') d.close(); else d.removeAttribute('open'); }
        o.addEventListener('click', function(){
          if(typeof d.showModal === 'function'){ if(!d.open) d.showModal(); } else d.setAttribute('open', '');
        });
        d.querySelectorAll('[data-lv-guide-fermer]').forEach(function(f){ f.addEventListener('click', fermer); });
        d.addEventListener('click', function(e){ if(e.target === d) fermer(); });
      });
      var form = champId ? champId.form : null;
      var complement = initComplement(p);
      // Cadeau de l'offre choisie et cases cochées (produits en plus) : ajoutés au panier avec l'offre
      function offreCochee(){ return p.querySelector('input[name="lv-offre"]:checked'); }
      function optionsCochees(){ return Array.prototype.slice.call(p.querySelectorAll('[data-lv-option]:checked')); }
      function lignesEnPlus(){
        var plus = [], r = offreCochee();
        if(r && r.dataset.lvCadeau) plus.push({ id: r.dataset.lvCadeau, quantite: parseInt(r.dataset.lvCadeauQte, 10) || 1 });
        optionsCochees().forEach(function(o){ plus.push({ id: o.dataset.lvOption, quantite: parseInt(o.dataset.lvOptionQte, 10) || 1 }); });
        return plus;
      }
      // Prix du bouton et de la barre = offre + cases cochées (seulement s'il y a des cases sur la page)
      function monnaie(c){
        var m = (c / 100).toFixed(2), f = p.dataset.lvFormat || '';
        if(!f) return 'CHF ' + m;
        return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(c / 100)))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, m.replace('.', ','))
          .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, m)
          .replace(/\{\{\s*amount\s*\}\}/, m);
      }
      function majPrixTotal(){
        if(!p.querySelector('[data-lv-option]')) return;
        var r = offreCochee(); if(!r || !r.dataset.lvCentimes) return;
        var total = parseInt(r.dataset.lvCentimes, 10) || 0;
        optionsCochees().forEach(function(o){ total += parseInt(o.dataset.lvOptionCentimes, 10) || 0; });
        var texte = p.dataset.lvTexteBouton || '';
        var t = p.dataset.lvPrixActif === 'false' ? texte : texte + ' · ' + monnaie(total);
        document.querySelectorAll('[data-lv-prix-bouton]').forEach(function(b){ b.textContent = t; });
        var bp = document.querySelector('[data-lv-barre-prix]'); if(bp) bp.textContent = monnaie(total);
      }
      p.querySelectorAll('[data-lv-option]').forEach(function(o){ o.addEventListener('change', majPrixTotal); });
      // Lignes à ajouter : une par couleur. Les pièces « Offert » (les dernières) partent en premier :
      // Shopify offre les premières lignes ajoutées, l'étiquette correspond ainsi au panier.
      function lignesChoisies(){ return lignesProduit().concat(lignesEnPlus()); }
      function lignesProduit(){
        var carte = p.querySelector('[data-lv-offre].choisie');
        var rangs = carte ? carte.querySelectorAll('[data-lv-piece]') : [];
        var totaux = {}, ordre = [];
        if(rangs.length){
          Array.prototype.slice.call(rangs).reverse().forEach(function(rang){
            var id = String(couleurPiece(+rang.dataset.lvPiece));
            if(!totaux[id]){ totaux[id] = 0; ordre.push(id); }
            totaux[id]++;
          });
        } else if(champId){
          ordre = [String(champId.value)]; totaux[ordre[0]] = parseInt(champQte && champQte.value, 10) || 1;
        }
        return ordre.map(function(id){ return { id: id, quantite: totaux[id] }; });
      }
      // Repli sans JavaScript du thème : envoi classique (items[n][id] / items[n][quantity]) puis page panier
      function preparerEnvoi(){
        if(!form) return;
        form.querySelectorAll('.lv-items').forEach(function(x){ x.remove(); });
        lignesChoisies().forEach(function(l, k){
          [['id', l.id], ['quantity', l.quantite]].forEach(function(kv){
            var e = document.createElement('input');
            e.type = 'hidden'; e.className = 'lv-items'; e.name = 'items[' + k + '][' + kv[0] + ']'; e.value = kv[1];
            form.appendChild(e);
          });
        });
        if(champId) champId.removeAttribute('name');
        if(champQte) champQte.removeAttribute('name');
      }
      // Ajout sans quitter la page : action standard Shopify du thème, puis ouverture du tiroir panier
      function actionsPanier(){ var a = window.Shopify && window.Shopify.actions; return a && a.updateCart ? a : null; }
      var envoiEnCours = false;
      function envoyer(){
        var act = actionsPanier();
        if(!act){ preparerEnvoi(); form.submit(); return; }
        if(envoiEnCours) return;
        envoiEnCours = true;
        var boutons = document.querySelectorAll('[data-lv-ajouter], [data-lv-barre] button, form[data-lv-bandeau-panier] button');
        boutons.forEach(function(b){ b.dataset.lvEtat = b.disabled ? '1' : ''; b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        var lignes = lignesChoisies().map(function(l){ return { merchandiseId: gidVariante(l.id), quantity: l.quantite }; });
        act.updateCart({ lines: lignes }, { event: { context: 'product' } })
          .then(function(res){
            if(res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
            if(complement){ complement.ouvrir(); return; }
            if(act.openCart) return act.openCart();
          })
          .catch(function(err){ console.warn('[Livelor] ajout au panier :', err); preparerEnvoi(); form.submit(); })
          .then(function(){
            envoiEnCours = false;
            boutons.forEach(function(b){ b.disabled = b.dataset.lvEtat === '1'; b.removeAttribute('aria-busy'); });
          });
      }
      if(form) form.addEventListener('submit', function(e){
        if(actionsPanier()){ e.preventDefault(); envoyer(); } else { preparerEnvoi(); }
      });
      // Offres
      var champQte = p.querySelector('[data-lv-quantite]');
      var boutons = document.querySelectorAll('[data-lv-prix-bouton]');
      var barreTitre = document.querySelector('[data-lv-barre-offre]');
      function choisir(r){
        if(champQte) champQte.value = r.dataset.lvQte;
        boutons.forEach(function(b){ b.textContent = r.dataset.lvPrix; });
        if(barreTitre) barreTitre.textContent = r.dataset.lvTitre;
        var lp = p.querySelector('[data-lv-ligne-prix]'), ld = p.querySelector('[data-lv-ligne-detail]'), bp = document.querySelector('[data-lv-barre-prix]');
        if(lp) lp.textContent = r.dataset.lvMontant; if(ld) ld.textContent = r.dataset.lvDetail; if(bp) bp.textContent = r.dataset.lvMontant;
        document.querySelectorAll('[data-lv-quantite-copie]').forEach(function(i){ i.value = r.dataset.lvQte; });
        p.querySelectorAll('[data-lv-offre]').forEach(function(c){ c.classList.toggle('choisie', c.contains(r)); });
        majPieces();
        majPrixTotal();
      }
      p.querySelectorAll('input[name="lv-offre"]').forEach(function(r){
        r.addEventListener('change', function(){ choisir(r); });
        if(r.checked) choisir(r);
      });
      // Lien direct vers une offre depuis le menu ou l'accueil : ?offre=2 ou ?offre=4 (nombre de pièces)
      var offreLien = (new URLSearchParams(location.search).get('offre') || '').replace(/\D/g, '');
      var rLien = offreLien && p.querySelector('input[name="lv-offre"][data-lv-qte="' + offreLien + '"]');
      if(rLien){ rLien.checked = true; choisir(rLien); }
      // Boutons « Choisir cette offre » ailleurs sur la page
      document.querySelectorAll('[data-lv-choisir-offre]').forEach(function(b){
        b.addEventListener('click', function(){
          var r = p.querySelector('input[name="lv-offre"][data-lv-qte="'+b.dataset.lvChoisirOffre+'"]');
          if(r){ r.checked = true; choisir(r); (r.closest('.lvp-offre') || p).scrollIntoView({behavior:'smooth', block:'center'}); }
        });
      });
      // Bouton « Ajouter au panier » d'un bandeau : même offre, mêmes couleurs que le bloc d'achat
      document.querySelectorAll('form[data-lv-bandeau-panier]').forEach(function(f){
        f.addEventListener('submit', function(e){
          var q = f.querySelector('[name="quantity"]');
          var r = q && p.querySelector('input[name="lv-offre"][data-lv-qte="' + q.value + '"]');
          if(!r || !form) return;
          e.preventDefault();
          r.checked = true; choisir(r); envoyer();
        });
      });
      // Barre d'achat collée (téléphone)
      var barre = document.querySelector('[data-lv-barre]');
      var ajouter = p.querySelector('[data-lv-ajouter]');
      if(barre && ajouter && 'IntersectionObserver' in window){
        new IntersectionObserver(function(es){
          es.forEach(function(e){ barre.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(ajouter);
      }
    });
  }


  // Fenêtre « Complétez votre panier » (section lv-produit, réglage comp_actif) : s'ouvre après chaque ajout au panier.
  // Le client choisit couleur et taille ; « Ajouter » met le produit au panier puis ouvre le panier ;
  // la croix (ou Échap, ou un clic à côté) ferme la fenêtre et ouvre le panier ; « Non merci » va au paiement.
  function initComplement(p){
    var d = document.getElementById(String(p.id || '').replace(/^lvp-/, 'lvp-comp-'));
    if(!d || !p.id) return null;
    if(d.parentNode !== document.body){
      Array.prototype.forEach.call(document.body.children, function(x){ if(x !== d && x.id === d.id) x.remove(); });
      document.body.appendChild(d);
    }
    var variantes = [];
    try { variantes = JSON.parse(d.querySelector('[data-lv-comp-variantes]').textContent); } catch(err){}
    var choix = [];
    d.querySelectorAll('[data-lv-comp-opt][aria-pressed="true"]').forEach(function(b){ choix[+b.dataset.lvCompOpt] = b.dataset.valeur; });
    var btn = d.querySelector('[data-lv-comp-ajouter]');
    var prix = d.querySelector('[data-lv-comp-prix]'), barre = d.querySelector('[data-lv-comp-barre]');
    var img = d.querySelector('.lvp-comp-img img');
    function courante(){
      for(var i = 0; i < variantes.length; i++){
        var v = variantes[i], ok = true;
        for(var k = 0; k < choix.length; k++){ if(choix[k] !== undefined && v.o[k] !== choix[k]){ ok = false; break; } }
        if(ok) return v;
      }
      return null;
    }
    function maj(){
      var v = courante();
      if(btn){ btn.disabled = !v || !v.d; if(v) btn.dataset.variante = v.id; }
      if(v){
        if(prix) prix.textContent = v.p;
        if(barre){ barre.textContent = v.b || ''; barre.hidden = !v.b; }
        if(img && v.i){ img.src = v.i; img.removeAttribute('srcset'); }
      }
      d.querySelectorAll('[data-lv-comp-val]').forEach(function(n){ var k = +n.dataset.lvCompVal; if(choix[k] !== undefined) n.textContent = choix[k]; });
    }
    d.querySelectorAll('[data-lv-comp-opt]').forEach(function(b){
      b.addEventListener('click', function(){
        var k = +b.dataset.lvCompOpt; choix[k] = b.dataset.valeur;
        d.querySelectorAll('[data-lv-comp-opt="' + k + '"]').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        maj();
      });
    });
    var versPaiement = false;
    function ouvrirPanier(){ var a = window.Shopify && window.Shopify.actions; if(a && a.openCart) a.openCart(); }
    function fermer(){ if(typeof d.close === 'function') d.close(); else { d.removeAttribute('open'); d.dispatchEvent(new Event('close')); } }
    d.addEventListener('close', function(){ if(!versPaiement) ouvrirPanier(); });
    d.querySelectorAll('[data-lv-comp-fermer]').forEach(function(f){ f.addEventListener('click', fermer); });
    d.addEventListener('click', function(e){ if(e.target === d) fermer(); });
    var non = d.querySelector('[data-lv-comp-non]');
    if(non) non.addEventListener('click', function(){ versPaiement = true; location.href = '/checkout'; });
    if(btn) btn.addEventListener('click', function(){
      var v = courante(); if(!v || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      var a = window.Shopify && window.Shopify.actions;
      function fin(){ btn.removeAttribute('aria-busy'); }
      if(!a || !a.updateCart){
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
          .then(function(){ versPaiement = true; location.href = '/cart'; }, fin);
        return;
      }
      a.updateCart({ lines: [{ merchandiseId: gidVariante(v.id), quantity: 1 }] }, { event: { context: 'product' } })
        .then(function(res){ if(res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message); fin(); fermer(); })
        .catch(function(err){ console.warn('[Livelor] complément :', err); fin(); });
    });
    maj();
    return {
      ouvrir: function(){ versPaiement = false; if(typeof d.showModal === 'function'){ if(!d.open) d.showModal(); } else d.setAttribute('open', ''); }
    };
  }

  // Rails défilants (cartes, galeries, avis) : points sous le rail et flèches, synchronisés avec le défilement au doigt.
  function initDefile(root){
    (root||document).querySelectorAll('[data-lv-defile]').forEach(function(c){
      if(c.dataset.lvInit) return; c.dataset.lvInit = '1';
      var rail = c.querySelector('[data-lv-defile-rail]'); if(!rail) return;
      var items = Array.prototype.slice.call(rail.children);
      var points = c.querySelector('[data-lv-defile-points]');
      var prec = c.querySelector('[data-lv-defile-prec]'), suiv = c.querySelector('[data-lv-defile-suiv]');
      var boutons = [];
      if(points){
        points.innerHTML = '';
        items.forEach(function(it, i){
          var b = document.createElement('button');
          b.type = 'button'; b.tabIndex = -1; b.setAttribute('aria-label', String(i + 1));
          b.addEventListener('click', function(){ aller(i); });
          points.appendChild(b); boutons.push(b);
        });
      }
      function defile(){ return rail.scrollWidth > rail.clientWidth + 4; }
      function actif(){
        var r = rail.getBoundingClientRect(), milieu = r.left + r.width / 2, best = 0, dist = Infinity;
        items.forEach(function(it, i){ var b = it.getBoundingClientRect(); var dd = Math.abs(b.left + b.width / 2 - milieu); if(dd < dist){ dist = dd; best = i; } });
        if(rail.scrollLeft <= 2) best = 0;
        if(rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2) best = items.length - 1;
        return best;
      }
      function marquer(){
        var i = actif();
        boutons.forEach(function(b, j){ b.classList.toggle('actif', j === i); });
        if(prec) prec.disabled = !defile() || rail.scrollLeft <= 2;
        if(suiv) suiv.disabled = !defile() || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        if(points) points.style.visibility = defile() ? '' : 'hidden';
      }
      function aller(i){
        var it = items[Math.max(0, Math.min(items.length - 1, i))]; if(!it) return;
        var r = rail.getBoundingClientRect(), b = it.getBoundingClientRect();
        rail.scrollBy({ left: b.left - r.left - (r.width - b.width) / 2, behavior: calme ? 'auto' : 'smooth' });
      }
      if(prec) prec.addEventListener('click', function(){ aller(actif() - 1); });
      if(suiv) suiv.addEventListener('click', function(){ aller(actif() + 1); });
      var t; rail.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(marquer, 60); }, { passive: true });
      window.addEventListener('resize', marquer);
      // Souris : on peut aussi faire glisser le rail en le tenant
      var tenu = false, x0 = 0, s0 = 0, bouge = false;
      rail.addEventListener('pointerdown', function(e){ if(e.pointerType !== 'mouse' || !defile()) return; tenu = true; bouge = false; x0 = e.clientX; s0 = rail.scrollLeft; rail.style.scrollSnapType = 'none'; });
      window.addEventListener('pointermove', function(e){ if(!tenu) return; var dx = e.clientX - x0; if(Math.abs(dx) > 4) bouge = true; rail.scrollLeft = s0 - dx; });
      window.addEventListener('pointerup', function(){ if(!tenu) return; tenu = false; rail.style.scrollSnapType = ''; aller(actif()); });
      rail.addEventListener('click', function(e){ if(bouge){ e.preventDefault(); e.stopPropagation(); bouge = false; } }, true);
      marquer();
    });
  }

  // Panier : couleur et taille de la proposition « Complétez votre panier » (snippet lv-panier-upsell)
  document.addEventListener('change', function(e){
    var sel = e.target.closest && e.target.closest('[data-lv-cp-opt]'); if(!sel) return;
    var bloc = sel.closest('[data-lv-cp]'); if(!bloc) return;
    var vs = []; try { vs = JSON.parse(bloc.querySelector('[data-lv-cp-variantes]').textContent); } catch(err){ return; }
    var choix = Array.prototype.map.call(bloc.querySelectorAll('[data-lv-cp-opt]'), function(x){ return x.value; });
    var v = vs.filter(function(x){ return x.o.every(function(o, k){ return o === choix[k]; }); })[0];
    var b = bloc.querySelector('[data-lv-upsell]');
    if(b){ b.disabled = !v || !v.d; if(v) b.dataset.lvUpsell = v.id; }
    var pr = bloc.querySelector('[data-lv-cp-prix]'); if(pr && v) pr.textContent = v.p;
  });

  // Date de livraison estimée : aujourd'hui + N jours ouvrables (week-ends exclus), format JJ.MM
  function initLivraison(root){
    (root||document).querySelectorAll('[data-lv-livraison]').forEach(function(el){
      var min = parseInt(el.dataset.min,10) || 10, max = parseInt(el.dataset.max,10) || min;
      function ajouter(n){ var d = new Date(); while(n > 0){ d.setDate(d.getDate() + 1); var j = d.getDay(); if(j !== 0 && j !== 6) n--; } return d; }
      function jjmm(d){ return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2); }
      var cible = el.querySelector('span'); if(!cible) return;
      cible.textContent = (el.dataset.modele || '').replace('[debut]', jjmm(ajouter(min))).replace('[fin]', jjmm(ajouter(max)));
      el.hidden = false;
    });
  }

  // Vidéos en boucle : chaque vidéo joue seulement quand elle est visible à l'écran (téléphone ou ordinateur),
  // se met en pause hors écran ; rien ne joue si la personne a demandé « moins d'animations »
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function jouer(v){
    v.muted = true; v.playsInline = true;
    if(v.paused){ v.preload = 'auto'; var lecture = v.play(); if(lecture && lecture.catch) lecture.catch(function(){}); }
  }
  var ioVideo = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){
      var v = e.target;
      if(e.isIntersecting && v.offsetParent !== null && !calme) jouer(v);
      else if(!v.paused) v.pause();
    });
  },{threshold:0.2}) : null;
  function initVideos(root){
    (root||document).querySelectorAll('[data-lv-video] video').forEach(function(v){
      if(v.dataset.lvObs) return; v.dataset.lvObs = '1';
      if(ioVideo) ioVideo.observe(v); else if(v.offsetParent !== null && !calme) jouer(v);
    });
  }


  // Listes dépliantes (onglets produit, FAQ) : ouverture et fermeture en douceur
  function initAccordeons(root){
    (root||document).querySelectorAll('[data-lv-accordeon] details').forEach(function(d){
      if(d.dataset.lvAcc) return; d.dataset.lvAcc = '1';
      var s = d.querySelector('summary'), c = s && s.nextElementSibling;
      if(!s || !c) return;
      s.addEventListener('click', function(e){
        if(calme || !c.animate) return;
        e.preventDefault();
        if(d.dataset.lvAnim) return;
        d.dataset.lvAnim = '1';
        var a;
        if(d.open){
          a = c.animate([{height: c.offsetHeight + 'px', opacity: 1}, {height: '0px', opacity: 0}], {duration: 240, easing: 'cubic-bezier(.2,.6,.2,1)', fill: 'forwards'});
          a.onfinish = function(){ d.open = false; a.cancel(); delete d.dataset.lvAnim; };
        } else {
          d.open = true;
          a = c.animate([{height: '0px', opacity: 0}, {height: c.offsetHeight + 'px', opacity: 1}], {duration: 280, easing: 'cubic-bezier(.2,.6,.2,1)'});
          a.onfinish = function(){ delete d.dataset.lvAnim; };
        }
      });
    });
  }

  // Avant / après : poignée à glisser (souris, doigt, clavier) + petit mouvement d'invitation à l'apparition
  function initAvantApres(root){
    (root||document).querySelectorAll('[data-lv-avant-apres]').forEach(function(c){
      if(c.dataset.lvInit) return; c.dataset.lvInit = '1';
      var range = c.querySelector('input[type="range"]');
      var depart = parseFloat(c.dataset.depart) || 50, touche = false, raf = 0;
      function poser(p){ p = Math.max(0, Math.min(100, p)); c.style.setProperty('--pos', p + '%'); if(range) range.value = Math.round(p); }
      function depuis(x){ var r = c.getBoundingClientRect(); if(r.width) poser((x - r.left) / r.width * 100); }
      var actif = false, x0 = 0, y0 = 0, souris = false;
      c.addEventListener('pointerdown', function(e){
        touche = true; cancelAnimationFrame(raf);
        souris = e.pointerType === 'mouse'; x0 = e.clientX; y0 = e.clientY;
        if(souris){ actif = true; depuis(e.clientX); c.classList.add('lvaa--manip'); if(c.setPointerCapture) c.setPointerCapture(e.pointerId); }
      });
      c.addEventListener('pointermove', function(e){
        if(!actif && !souris && Math.abs(e.clientX - x0) > 6 && Math.abs(e.clientX - x0) > Math.abs(e.clientY - y0)){
          actif = true; c.classList.add('lvaa--manip'); if(c.setPointerCapture) c.setPointerCapture(e.pointerId);
        }
        if(actif) depuis(e.clientX);
      });
      function fin(e){
        if(!actif && !souris && e && e.type === 'pointerup' && Math.abs(e.clientX - x0) < 6 && Math.abs(e.clientY - y0) < 6) depuis(e.clientX);
        actif = false; c.classList.remove('lvaa--manip');
      }
      c.addEventListener('pointerup', fin);
      c.addEventListener('pointercancel', fin);
      if(range){
        range.addEventListener('input', function(){ touche = true; cancelAnimationFrame(raf); poser(+range.value); });
      }
      if(c.dataset.indice && !calme && 'IntersectionObserver' in window){
        var obs = new IntersectionObserver(function(es){
          es.forEach(function(e){
            if(!e.isIntersecting) return;
            obs.disconnect();
            var t0 = null, duree = 1600;
            function pas(t){
              if(touche) return;
              if(t0 === null) t0 = t;
              var k = Math.min(1, (t - t0) / duree);
              poser(depart + Math.sin(k * Math.PI * 2) * 12 * (1 - k * 0.3));
              if(k < 1) raf = requestAnimationFrame(pas); else poser(depart);
            }
            setTimeout(function(){ if(!touche) raf = requestAnimationFrame(pas); }, 450);
          });
        }, {threshold: 0.6});
        obs.observe(c);
      }
    });
  }

  // Éditeur de thème : un onglet ou une question sélectionné s'ouvre
  document.addEventListener('shopify:block:select', function(e){
    var d = e.target && e.target.closest ? e.target.closest('details') : null;
    if(d) d.open = true;
  });

  // Panier : un clic sur le voile (ordinateur) ou sur « Continuer mes achats » ferme le tiroir
  function fermerPanier(){ var d = document.getElementById('cart-drawer'); if(d && d.hasAttribute('open') && typeof d.close === 'function') d.close(); }
  document.addEventListener('click', function(e){
    if(e.target === document.body || (e.target.closest && e.target.closest('[data-lv-fermer-panier]'))) fermerPanier();
  });

  // Identifiant de variante au format attendu par les actions panier de Shopify
  function gidVariante(id){ id = String(id); return id.indexOf('gid://') === 0 ? id : 'gid://shopify/ProductVariant/' + id; }
  function actionsShopify(){ var a = window.Shopify && window.Shopify.actions; return a && a.updateCart ? a : null; }
  function ajoutClassique(id, q, apres){
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +String(id).split('/').pop(), quantity: q }] }) })
      .then(function(){ if(apres === 'panier') location.href = '/cart'; else location.reload(); });
  }

  // Panier : boutons « Ajouter » des propositions (upsells), le panier se met à jour sans quitter la page
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-lv-upsell]');
    if(!b) return;
    e.preventDefault();
    if(b.getAttribute('aria-busy') === 'true') return;
    var id = b.dataset.lvUpsell, q = parseInt(b.dataset.lvUpsellQte, 10) || 1;
    b.setAttribute('aria-busy', 'true'); b.disabled = true;
    function fin(){ b.removeAttribute('aria-busy'); b.disabled = false; }
    var act = actionsShopify();
    if(!act){ ajoutClassique(id, q, 'panier'); return; }
    act.updateCart({ lines: [{ merchandiseId: gidVariante(id), quantity: q }] }, { event: { context: 'cart' } })
      .then(function(res){ if(res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message); })
      .catch(function(err){ console.warn('[Livelor] proposition panier :', err); return ajoutClassique(id, q); })
      .then(fin, fin);
  });

  // Panier : un cadeau (ex. fils offerts) sans la quantité requise (ex. moins de 2 kits) est retiré automatiquement.
  // Le repère [data-lv-cadeau-orphelin] est posé par le snippet lv-panier-upsell quand la condition n'est plus remplie.
  var retraitEnCours = false;
  function retirerCadeauOrphelin(){
    var m = document.querySelector('[data-lv-cadeau-orphelin]');
    if(!m || retraitEnCours) return;
    retraitEnCours = true;
    var vid = String(m.dataset.lvCadeauOrphelin), qte = parseInt(m.dataset.lvCadeauQte, 10) || 0, act = actionsShopify();
    function fin(){ retraitEnCours = false; }
    function classique(){
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: m.dataset.lvCle, quantity: qte }) }).then(function(){ location.reload(); });
    }
    if(!act || !act.getCart){ classique().then(fin, fin); return; }
    // Les lignes des actions et celles de /cart.js sont dans le même ordre : on repère la ligne du cadeau par sa position
    Promise.all([act.getCart(), fetch('/cart.js').then(function(r){ return r.json(); })])
      .then(function(res){
        var lignes = (res[0] && res[0].cart && res[0].cart.lines && (res[0].cart.lines.nodes || res[0].cart.lines)) || [];
        var articles = (res[1] && res[1].items) || [];
        var maj = [];
        articles.forEach(function(it, i){ if(String(it.variant_id) === vid && lignes[i] && lignes[i].id) maj.push({ id: lignes[i].id, quantity: qte }); });
        if(!maj.length || lignes.length !== articles.length) return classique();
        return act.updateCart({ lines: maj }, { event: { context: 'cart' } });
      })
      .catch(function(err){ console.warn('[Livelor] cadeau :', err); return classique(); })
      .then(fin, fin);
  }
  if('MutationObserver' in window){
    var prevuCadeau = false;
    new MutationObserver(function(){
      if(prevuCadeau) return; prevuCadeau = true;
      requestAnimationFrame(function(){ prevuCadeau = false; retirerCadeauOrphelin(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init(root){ initApparition(root); initDefile(root); initProduit(root); initLivraison(root); initVideos(root); initAccordeons(root); initAvantApres(root); retirerCadeauOrphelin(); }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function(){ init(); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
